import React, { createContext, useContext, useState } from "react";

const PeriodContext = createContext(null);

export function PeriodProvider({ children }) {
  const today = new Date();
  const [month, setMonth] = useState(today.getMonth() + 1);
  const [year, setYear] = useState(today.getFullYear());
  const [view, setView] = useState("month");
  const [refreshKey, setRefreshKey] = useState(0);
  const bump = () => setRefreshKey((v) => v + 1);

  return (
    <PeriodContext.Provider
      value={{ month, year, view, setMonth, setYear, setView, refreshKey, bump }}
    >
      {children}
    </PeriodContext.Provider>
  );
}

export const usePeriod = () => useContext(PeriodContext);
